import { Link } from "react-router-dom";
import { Clock } from "lucide-react";

export default function ArticleCard({ a, variant = "default", index = 0 }) {
  if (variant === "feature") {
    return (
      <Link
        to={`/articles/${a.id}`}
        data-testid={`article-feature-${a.id}`}
        className="group block animate-fade-up"
        style={{ animationDelay: `${index * 80}ms` }}
      >
        <div className="img-zoom aspect-[3/4] bg-sand-100 mb-6 relative">
          <img src={a.cover_image} alt={a.title} className="w-full h-full object-cover" loading="lazy" />
          <div className="absolute inset-x-0 bottom-0 p-6 bg-gradient-to-t from-black/80 to-transparent">
            <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-ochre-400">
              {a.category}
            </span>
          </div>
        </div>
        <h3 className="font-serif text-2xl lg:text-3xl font-bold text-sand-900 leading-tight group-hover:text-brand-500 transition-colors">
          {a.title}
        </h3>
        <div className="mt-3 text-xs font-mono uppercase tracking-widest text-sand-600 flex items-center gap-3">
          <span>{a.author}</span>
          <span>·</span>
          <span className="flex items-center gap-1.5"><Clock size={11} /> {a.read_time}</span>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/articles/${a.id}`}
      data-testid={`article-card-${a.id}`}
      className="group flex gap-5 items-start animate-fade-up"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="img-zoom w-32 h-32 md:w-40 md:h-40 flex-shrink-0 bg-sand-100">
        <img src={a.cover_image} alt={a.title} className="w-full h-full object-cover" loading="lazy" />
      </div>
      <div className="flex-1 min-w-0">
        <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-brand-500">
          {a.category}
        </span>
        <h3 className="mt-2 font-serif text-lg md:text-xl font-bold text-sand-900 leading-snug group-hover:text-brand-500 transition-colors line-clamp-2">
          {a.title}
        </h3>
        <p className="hidden md:block mt-2 text-sm text-sand-700 font-light line-clamp-2">
          {a.excerpt}
        </p>
        <div className="mt-3 text-[11px] font-mono uppercase tracking-widest text-sand-600">
          {a.author} · {a.read_time}
        </div>
      </div>
    </Link>
  );
}
